module.exports = __webpack_public_path__ + "img/glory-low-contrast.4db5580d.jpg";